import QuestionnaireType from 'common/questionnaires/QuestionnaireType';

export const QUESTIONNAIRE_NEW = 'QUESTIONNAIRE_NEW';

function start(questionnaireType, rcEnabled, formType, formGroup, selectedAccountId, customerDetails, lockSettings) {
  return {
    type: QUESTIONNAIRE_NEW,
    questionnaireType,
    rcEnabled,
    formType,
    formGroup,
    selectedAccountId,
    customerDetails,
    lockSettings
  };
}

export function newQuestionnaire(questionnaireType, formType = null, formGroup = null, selectedAccountId = null, customerDetails = null, lockSettings = null) {
  return (dispatch) => {
    dispatch(start(questionnaireType, null, formType, formGroup, selectedAccountId, customerDetails, lockSettings));
  };
}

export function newFormQuestionnaire(formType, selectedAccountId, customerDetails, lockSettings) {
  return (dispatch) => {
    dispatch(start(QuestionnaireType.Form, null, formType, null, selectedAccountId, customerDetails, lockSettings));
  };
}

export function newFormGroupQuestionnaire(formGroup, selectedAccountId, customerDetails, lockSettings) {
  return (dispatch) => {
    dispatch(start(QuestionnaireType.FormGroup, null, null, formGroup, selectedAccountId, customerDetails, lockSettings));
  };
}

export function newPreQualQuestionnaire(rcEnabled, customerDetails) {
  return (dispatch) => {
    dispatch(start(QuestionnaireType.PreQualifying, rcEnabled, null, null, null, customerDetails));
  };
}
